export function createCountrySummary(airports, routes) {
  const summary = {
    total: {
      iso: "total",
      name: "Total",
      airportCount: 0,
      airportTypes: {},
      routeCount: 0,
      totalDistance: 0,
      domesticRoutes: 0,
      internationalRoutes: 0,
    },
  };

  // 1) Airports → per-country + total
  for (const a of airports) {
    const { iso, name } = a.country || {};
    if (!iso) continue;

    // ensure per-country bucket
    const bucket = (summary[iso] ??= {
      iso,
      name,
      airportCount: 0,
      airportTypes: {},
      routeCount: 0,
      totalDistance: 0,
      domesticRoutes: 0,
      internationalRoutes: 0,
    });

    // increment per-country
    bucket.airportCount++;
    bucket.airportTypes[a.type] = (bucket.airportTypes[a.type] || 0) + 1;

    // also increment total
    summary.total.airportCount++;
    summary.total.airportTypes[a.type] =
      (summary.total.airportTypes[a.type] || 0) + 1;
  }

  // 2) Routes → per-country + total
  const internationalMap = new Map();

  for (const r of routes) {
    const isInternational = r.countries.length === 2;
    // if (isInternational) internationalSet.add(r._id);
    for (const iso of r.countries) {
      const bucket = (summary[iso] ??= {
        iso,
        name: iso,
        airportCount: 0,
        airportTypes: {},
        routeCount: 0,
        totalDistance: 0,
        domesticRoutes: 0,
        internationalRoutes: 0,
      });

      // per-country
      bucket.routeCount++;
      bucket.totalDistance += r.distance;
      if (isInternational) bucket.internationalRoutes++;
      else bucket.domesticRoutes++;

      // total
      summary.total.routeCount++;
      summary.total.totalDistance += r.distance;
      if (isInternational) summary.total.internationalRoutes++;
      else summary.total.domesticRoutes++;
    }
  }

  return summary;
}
